import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import ElementPlus from 'element-plus';
import '@as/style/element.scss';
import 'animate.css';
const app = createApp(App);
app.use(router).use(ElementPlus).mount('#app')
